<template>
	<table class="table table-responsive table-hover admin-table">
		<thead>
			<tr>
				<th>N°</th>
				<th>N° ORDEN</th>
				<th>COMPRADOR </th>
				<th>EMAIL </th>
				<th>STATUS</th>
				<th>TIPO DE ENVIO</th>
				<th>MONTO </th>
				<th>FECHA</th>
				<th>ARCHIVO</th>
				<th>PAGADO</th>
			</tr>
		</thead>
		<tbody>
			<tr class="clickable-row" v-for="item in render_list | filterBy query">
				<td>{{ $index + 1 }}</td>
				<td>{{ item.payment_id }}</td>
				<td>{{ item.user.name }}</td>
				<td>{{ item.user.email }}</td>
				<td>
					<select class="form-control" v-model="item.deliver_status" @change="changeDelivered(item)">
						<option value="Not sent">Pendiente</option>
						<option value="Sent">Enviado</option>
						<option value="delivered">Recibido</option>
					</select>
				</td>
				<td>{{ item.shippment_type }}</td>
				<td>${{ parseFloat(item.purchase_total).toFixed(2) }}</td> 
				<td>{{ moment(item.created_at).format('YYYY-MM-DD ~ hh:mm:ss') }}</td>
				<td><a href="{{ link }}/admin/purchaseOrders/{{ item.id }}/pdf?api_token={{ current_user.token }}">
					Descargar
				</a></td>
				<td>
					<div class="custom-checkbox-gray" style="margin-top: 10px;">
						<input type="checkbox" :id="item.name" :checked="item.is_paid">
						<label :for="item.name" @click="togglePaid(item)"></label>
			      	</div>
				</td>
			</tr>
		</tbody>
	</table>
	<!-- <pagination></pagination> -->
</template>

<script>
import { api_base } from '../../store/api';
import { checkPurchasePaid, changeDeliveredStatus } from '../../store/actions';
import moment from 'moment/min/moment.min.js';

export default {
	// ---- PROPS ----

	props: ['list', 'url', 'remove', 'query'],

	// ---- DATA ----
	
	data() {
		return {
			link: api_base
		};
	},

	// ---- VUEX ----

	vuex: {
		getters: {
			current_user: state => state.current_user
		},
		actions: {
			checkPurchasePaid,
			changeDeliveredStatus
		}
	},

	// ---- METHODS ----

	methods: {
		togglePaid (order) {
			order.is_paid = true;
			this.checkPurchasePaid(this.current_user, order);
		},

		changeDelivered (order) {
			let status = 0;

			switch (order.deliver_status) {
				case 'Not sent': status = 0; break;
				case 'Sent': status = 1; break;
				case 'delivered': status = 2; break;
			}

			let delivered_wrap = {
				id: order.id,
				deliver_status_str: order.deliver_status,
				deliver_status: status
			};

			this.changeDeliveredStatus(this.current_user, delivered_wrap);
		},

		moment
	},

	// ---- RENDER ----

	computed: {
		render_list () {
			for (let i = 0, l = this.list; i < l.length; i++) {
				if (l[i].paid == l[i].purchase_total) {
					l[i].is_paid = true;
				} else {
					l[i].is_paid = false;
				}
			}

			return this.list;
		},

		render_url () {
			return this.url;
		}
	}
}
</script>


// WEBPACK FOOTER //
// Admin-table-order.vue?7386bf22